module.exports = __webpack_public_path__ + "img/change-sector.3f1df06a.svg";